import { NotificationSettingsEnum } from '../base-types';

// eslint-disable-next-line import-x/prefer-default-export
export const notificationSettingsTree = [
  {
    key: NotificationSettingsEnum.SECTION_MESSAGING,
    pages: [
      {
        key: NotificationSettingsEnum.MESSAGING_ALL_CHATS,
        actions: [
          {
            key: NotificationSettingsEnum.MESSAGING_ALL_CHATS_CHAT_ASSIGNED_TO_YOU_BY_ANOTHER_EMPLOYEE_ACTION,
          },
          {
            key: NotificationSettingsEnum.MESSAGING_ALL_CHATS_NEW_MESSAGE_AT_NOT_ASSIGNED_CHAT_ACTION,
          },
          {
            key: NotificationSettingsEnum.MESSAGING_ALL_CHATS_NEW_MESSAGE_CHAT_ASSIGNED_TO_YOU_ACTION,
          },
          {
            key: NotificationSettingsEnum.MESSAGING_ALL_CHATS_YOU_REMOVED_AS_ASSIGNEE_FROM_CHAT_BY_ANOTHER_EMPLOYEE_ACTION,
          },
        ],
      },
    ],
  },
  {
    key: NotificationSettingsEnum.SECTION_CUSTOMERS,
    pages: [
      {
        key: NotificationSettingsEnum.INDIVIDUAL_CUSTOMERS,
        actions: [
          {
            key: NotificationSettingsEnum.INDIVIDUAL_CUSTOMERS_AGREEMENTS_SIGNED_BY_CUSTOMER_ACTION,
          },
          {
            key: NotificationSettingsEnum.INDIVIDUAL_CUSTOMERS_DOCUMENT_WILL_EXPIRED_AFTER_14_DAYS_ACTION,
          },
          {
            key: NotificationSettingsEnum.INDIVIDUAL_CUSTOMERS_DOCUMENT_WILL_EXPIRED_AFTER_31_DAYS_ACTION,
          },
          {
            key: NotificationSettingsEnum.INDIVIDUAL_CUSTOMERS_NEW_BENEFICIARY_REQUIRED_APPROVAL_ACTION,
          },
          {
            key: NotificationSettingsEnum.INDIVIDUAL_CUSTOMERS_NEW_CONTRACT_REQUIRED_APPROVAL_ACTION,
          },
          {
            key: NotificationSettingsEnum.INDIVIDUAL_CUSTOMERS_ONGOING_MONITORING_MATCHES_FOUND_ACTION,
          },
          {
            key: NotificationSettingsEnum.INDIVIDUAL_CUSTOMERS_RISK_SCORE_UPDATED_ACTION,
          },
        ],
      },
      {
        key: NotificationSettingsEnum.CORPORATE_CUSTOMERS,
        actions: [
          {
            key: NotificationSettingsEnum.CORPORATE_CUSTOMERS_AGREEMENTS_SIGNED_BY_CUSTOMER_ACTION,
          },
          {
            key: NotificationSettingsEnum.CORPORATE_CUSTOMERS_DOCUMENT_WILL_EXPIRED_AFTER_14_DAYS_ACTION,
          },
          {
            key: NotificationSettingsEnum.CORPORATE_CUSTOMERS_DOCUMENT_WILL_EXPIRED_AFTER_31_DAYS_ACTION,
          },
          {
            key: NotificationSettingsEnum.CORPORATE_CUSTOMERS_NEW_BENEFICIARY_REQUIRED_APPROVAL_ACTION,
          },
          {
            key: NotificationSettingsEnum.CORPORATE_CUSTOMERS_NEW_CONTRACT_REQUIRED_APPROVAL_ACTION,
          },
          {
            key: NotificationSettingsEnum.CORPORATE_CUSTOMERS_NEW_COF_CREATED_BY_CUSTOMER_ACTION,
          },
          {
            key: NotificationSettingsEnum.CORPORATE_CUSTOMERS_ONGOING_MONITORING_MATCHES_FOUND_ACTION,
          },
          {
            key: NotificationSettingsEnum.CORPORATE_CUSTOMERS_RISK_SCORE_UPDATED_ACTION,
          },
        ],
      },
      {
        key: NotificationSettingsEnum.APPLICATIONS,
        actions: [
          {
            key: NotificationSettingsEnum.APPLICATIONS_ALL_COF_OF_CORPORATE_CUSTOMER_ACCEPTED_ACTION,
          },
          {
            key: NotificationSettingsEnum.APPLICATIONS_APPLICATION_ASSIGNED_TO_YOU_ACTION,
          },
          {
            key: NotificationSettingsEnum.APPLICATIONS_APPLICATION_IS_READY_TO_REVIEW_ACTION,
          },
          {
            key: NotificationSettingsEnum.APPLICATIONS_COF_OF_CORPORATE_CUSTOMER_REJECTED_ACTION,
          },
          {
            key: NotificationSettingsEnum.APPLICATIONS_COMMENT_ADDED_AT_ANY_APPLICATION_ACTION,
          },
          {
            key: NotificationSettingsEnum.APPLICATIONS_COMMENT_ADDED_AT_ASSIGNED_TO_YOU_APPLICATIONS_ACTION,
          },
          {
            key: NotificationSettingsEnum.APPLICATIONS_NEW_APPLICATION_CREATED_BY_CUSTOMER_ACTION,
          },
          {
            key: NotificationSettingsEnum.APPLICATIONS_SUMSUB_VERIFICATION_STATUS_FAILED_ACTION,
          },
        ],
      },
    ],
  },
  {
    key: NotificationSettingsEnum.SECTION_TRANSACTIONS,
    pages: [
      {
        key: NotificationSettingsEnum.TRANSACTIONS_INCOMING,
        actions: [
          {
            key: NotificationSettingsEnum.TRANSACTIONS_INCOMING_NEW_INCOMING_TRANSACTION_CREATED_BY_EMPLOYEE_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_INCOMING_NEW_INCOMING_TRANSACTION_CREATED_BY_INTEGRATION_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_INCOMING_TRANSACTION_AT_AML_INFO_STATUS_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_INCOMING_TRANSACTION_AT_AML_STATUS_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_INCOMING_TRANSACTION_AT_REV_STATUS_ACTION,
          },
        ],
      },
      {
        key: NotificationSettingsEnum.TRANSACTIONS_OUTGOING,
        actions: [
          {
            key: NotificationSettingsEnum.TRANSACTIONS_OUTGOING_NEW_OUTGOING_TRANASCTION_CREATED_BY_CUSTOMER_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_OUTGOING_NEW_OUTGOING_TRANASCTION_CREATED_BY_EMPLOYEE_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_OUTGOING_NEW_OUTGOING_TRANASCTION_CREATED_BY_INTEGRATION_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_OUTGOING_TRANSACTION_AT_AML_INFO_STATUS_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_OUTGOING_TRANSACTION_AT_AML_STATUS_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_OUTGOING_TRANSACTION_AT_ARCH_STATUS_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_OUTGOING_TRANSACTION_AT_READY_TO_PSP_STATUS_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_OUTGOING_TRANSACTION_AT_READY_TO_SENT_STATUS_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_OUTGOING_TRANSACTION_AT_REV_STATUS_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_OUTGOING_TRANSACTION_AT_SENT_STATUS_ACTION,
          },
        ],
      },
      {
        key: NotificationSettingsEnum.TRANSACTIONS_INTERNAL,
        actions: [
          {
            key: NotificationSettingsEnum.TRANSACTIONS_INTERNAL_NEW_INTERNAL_TRANSACTION_CREATED_BY_CUSTOMER_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_INTERNAL_NEW_INTERNAL_TRANSACTION_CREATED_BY_EMPLOYEE_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_INTERNAL_TRANSCATION_AT_AML_INFO_STATUS_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_INTERNAL_TRANSCATION_AT_AML_STATUS_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_INTERNAL_TRANSCATION_AT_ARCH_STATUS_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_INTERNAL_TRANSCATION_AT_REV_STATUS_ACTION,
          },
        ],
      },
      {
        key: NotificationSettingsEnum.TRANSACTIONS_EXCHANGE,
        actions: [
          {
            key: NotificationSettingsEnum.TRANSACTIONS_EXCHANGE_TRANSACTION_AT_ARCH_STATUS_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_EXCHANGE_TRANSACTION_AT_FX_RATE_REQUEST_STATUS_ACTION,
          },
          {
            key: NotificationSettingsEnum.TRANSACTIONS_EXCHANGE_TRANSACTION_AT_NEW_STATUS_ACTION,
          },
        ],
      },
    ],
  },
  {
    key: NotificationSettingsEnum.SECTION_REPORTS,
    pages: [
      {
        key: NotificationSettingsEnum.REPORTS_ALL,
        actions: [
          { key: NotificationSettingsEnum.REPORTS_ALL_DAY_CLOSED_ACTION },
        ],
      },
      {
        key: NotificationSettingsEnum.REPORTS_RESTATEMENT,
        actions: [
          {
            key: NotificationSettingsEnum.REPORTS_RESTATEMENT_GL_RESTATEMENT_COMPLETED_ACTION,
          },
          {
            key: NotificationSettingsEnum.REPORTS_RESTATEMENT_RESTATEMENT_COMPLETED_ACTION,
          },
          {
            key: NotificationSettingsEnum.REPORTS_RESTATEMENT_STATEMENT_ITEMS_RESTATEMENT_COMPLETED_ACTION,
          },
        ],
      },
    ],
  },
  {
    key: NotificationSettingsEnum.SECTION_ADMINISTRATION,
    pages: [
      {
        key: NotificationSettingsEnum.NOTIFICATIONS_ALL,
        actions: [
          {
            key: NotificationSettingsEnum.NOTIFICATIONS_ALL_NOTIFICATION_UPDATED_ACTION,
          },
          {
            key: NotificationSettingsEnum.NOTIFICATIONS_ALL_NOTIFICATION_WITH_ASSIGNEE_AS_ME_UPDATED_ACTION,
          },
          {
            key: NotificationSettingsEnum.NOTIFICATIONS_ALL_NOTIFICATION_WITH_RESPONSIBLE_AS_ME_UPDATED_ACTION,
          },
        ],
      },
    ],
  },
];
